import React, { FC, useState } from "react";
import styled from "styled-components";
import { ExpertText, SmallText } from "../../../Components/Text3D";
import { PrimaryButtonX } from "../../../Components/Button3D";
import { Row, Upload, Spin, notification } from "antd";
import UploadImg from '../../../assets/images/uploadImg.png';
import { useStoreActions, useStoreState } from "../../../myStore";
import { useHistory } from "react-router-dom";

const { Dragger } = Upload;

const MainContainer = styled(Row)`
  /* &:before {
    content: "";
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 20px solid white;
    margin-left: 35rem;
  } */
`;

const ContentDiv = styled.div`
  background-color: white;
  font-family: "Planer", -apple-system, BlinkMacSystemFont, sans-serif;
  width: 100%;
  padding-bottom: 2rem;
`;
const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2.5rem 0.5rem 1rem 0.5rem;
  margin: 0 2rem;
  border-bottom: 1px solid #d8d8d8;
`;
const ContentSection = styled.div`
  /* margin: 2rem 0; */
`;
const StyledDiv = styled.div`
  border: 1px solid #d8d8d8;
  margin: 0 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem 0;
`;
const DragSection = styled(Dragger)`
  background: white;
  justify-content: center;
  border: none;
`;
interface IProps {
  hasSTL?: boolean
}
const ImgDiv = styled.div<IProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #1196dd;
  box-sizing: border-box;
  height: ${props => props.hasSTL ? '300px' : '116px'};
  width: ${props => props.hasSTL ? 'auto' : '116px'};
  margin-bottom: 2rem;
  margin: 0 auto;
`;
interface Props {
  handleClick(data: any): any;
  collectedDatas: any;
}

const UploadNewDesignPage: FC<Props> = ({ handleClick }) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [rawFile, setRawFile] = useState<any>()

  const designFormData = useStoreState((state) => state.design.designFormData);
  const setDesignFormData = useStoreActions((actions) => actions.design.setDesignFormData);

  const props = {
    name: "file",
    multiple: false,
    beforeUpload: async (file: any, fileList) => {
      setLoading(false);
      return false;
    },
    onChange: (info) => {
      setRawFile(info.fileList);
    }
  };
  const handleUrlClick = () => {
    if (!rawFile) {
      notification.error({
        message: "Error",
        description: "Please upload an image",
      });
    } else {
      setDesignFormData({ ...designFormData, rawFile });
      history.push("/dashboard/design/publish")
    }
  };
  return (
    <Spin spinning={loading}>
      <MainContainer>
        <ContentDiv>
          <TopSection>
            <ExpertText dark>
              Dashboard / <a href="/dashboard/design/addnew">Upload New Design</a>
            </ExpertText>
          </TopSection>
          <ContentSection>
            <StyledDiv>
              <DragSection
                {...props}
                accept=".stl"
                style={{ border: "none", background: "white" }}
              >
                <ImgDiv>
                  <img
                    src={UploadImg}
                    alt=""
                  />
                </ImgDiv>
                <SmallText style={{ paddingBottom: ".5rem" }}>
                  <span>Upload files & other formats.</span>
                </SmallText>
                <ExpertText dark>(Drag or click to upload)</ExpertText>
              </DragSection>
            </StyledDiv>
            <div style={{ display: 'flex', flexFlow: 'row', justifyContent: 'flex-end' }}>
              <PrimaryButtonX
                type="primary"
                style={{ margin: "2rem 2rem 0 0" }}
                onClick={handleUrlClick}
              >
                next
              </PrimaryButtonX>
            </div>
          </ContentSection>
        </ContentDiv>
      </MainContainer>
    </Spin >
  );
};

export default UploadNewDesignPage;
